import React from 'react';
import type { SVGProps } from 'react';

import notionIconUrl from '../../../../assets/icons/notion-icon.svg?url';

interface NotionIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const NotionIcon: React.FC<NotionIconProps> = ({ size = 20 }) => (
  <img
    src={notionIconUrl}
    width={size}
    height={size}
    alt="Notion"
    style={{ display: 'block' }}
  />
);

export default NotionIcon;